var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24663 1.66732L9.46663 3.00065H12.1666V11.0007H1.49996V3.00065H4.19996L5.41996 1.66732H8.24663ZM8.83329 0.333984H4.83329L3.61329 1.66732H1.49996C0.766626 1.66732 0.166626 2.26732 0.166626 3.00065V11.0007C0.166626 11.734 0.766626 12.334 1.49996 12.334H12.1666C12.9 12.334 13.5 11.734 13.5 11.0007V3.00065C13.5 2.26732 12.9 1.66732 12.1666 1.66732H10.0533L8.83329 0.333984ZM6.83329 5.00065C7.93329 5.00065 8.83329 5.90065 8.83329 7.00065C8.83329 8.10065 7.93329 9.00065 6.83329 9.00065C5.73329 9.00065 4.83329 8.10065 4.83329 7.00065C4.83329 5.90065 5.73329 5.00065 6.83329 5.00065ZM6.83329 3.66732C4.99329 3.66732 3.49996 5.16065 3.49996 7.00065C3.49996 8.84065 4.99329 10.334 6.83329 10.334C8.67329 10.334 10.1666 8.84065 10.1666 7.00065C10.1666 5.16065 8.67329 3.66732 6.83329 3.66732Z",
    fill: "#0099D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0761494c.svg";
export { ForwardRef as ReactComponent };